var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.7498,
    cy: 3.75,
    rx: 3.57353,
    ry: 3.75,
    fill: "#607783"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.75C0.895431 9.75 0 10.6454 0 11.75V18H13.5V11.75C13.5 10.6454 12.6046 9.75 11.5 9.75H8.9147L7.26544 13.0904C7.45628 13.114 7.64721 13.1658 7.83121 13.2481C8.72999 13.6499 9.12326 14.6247 8.70959 15.4254C8.29593 16.226 7.23198 16.5494 6.3332 16.1476L6.32285 16.1429L5.73184 17.2883C5.65585 17.4356 5.47163 17.5001 5.32037 17.4324L4.25269 16.9544C4.10143 16.8867 4.04041 16.7124 4.1164 16.5652L5.43884 14.0021C5.44402 13.9915 5.44935 13.9809 5.45482 13.9703C5.46003 13.9602 5.46534 13.9502 5.47076 13.9403L5.50672 13.8706L5.51021 13.8721C5.696 13.5695 5.97939 13.3442 6.30897 13.2118L4.59976 9.75H2ZM5.47597 9.75L6.75723 12.345L8.03849 9.75H5.47597Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainer);
export default __webpack_public_path__ + "static/media/trainer.b4cf9f11d8b5767791515676e7b6b975.svg";
export { ForwardRef as ReactComponent };